import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RxUtils } from '@utils';
import { authService } from '@services';
import { LoadingLayout } from '@components/common';

export const Login2: FC = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const data = searchParams.get('data') || '';
	const organizationId = searchParams.get('organizationId') || '';

	useEffect(() => {
		organizationId &&
			data &&
			RxUtils.promisify(
				authService.login2(organizationId, data),
				() => navigate('/portal'),
				() => navigate('/login')
			);
	}, [organizationId, data]);

	return <LoadingLayout />;
};
